export default __webpack_public_path__ + "static/media/z_wdt_c_1.ed6e8823.mp3";